import { render, staticRenderFns } from "./roomCreateFeeAdd.vue?vue&type=template&id=7b06c38c&scoped=true"
import script from "./roomCreateFeeAdd.vue?vue&type=script&lang=js"
export * from "./roomCreateFeeAdd.vue?vue&type=script&lang=js"
import style0 from "./roomCreateFeeAdd.vue?vue&type=style&index=0&id=7b06c38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06c38c",
  null
  
)

export default component.exports